import { ButtonBase, Typography } from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface FilterTagProps {
	name: string;
	count?: number;
	isSelected: boolean;
	onSelect: (value: string) => void;
}

function FilterTag({ name, count, isSelected, onSelect }: FilterTagProps) {
	return (
		<ButtonBase
			onClick={() => onSelect(name)}
			sx={{
				backgroundColor: isSelected ? '#D9FDD3' : '#F0F2F5',
				border: `1px solid ${isSelected ? '#B7E8DA' : 'transparent'}`,
				borderRadius: '14px',
				px: 1.15,
				py: 0.45,
				whiteSpace: 'nowrap',
				'&:hover': {
					backgroundColor: isSelected ? '#CFF5C9' : '#E9EDEF',
				},
			}}>
			<Typography
				fontSize="11px"
				fontWeight={isSelected ? 700 : 600}
				color={isSelected ? MAIN_THEME_COLOR : '#54656F'}>
				{`${name} ${count ?? 0}`}
			</Typography>
		</ButtonBase>
	);
}

export default FilterTag;
